export enum MedplumSystems {
  BotIdentifier = "https://www.medplum.com/integrations/bot-identifier",
}
